import api from '../../../api/axios';
import { API_ENDPOINTS } from '../../../api/endpoints';

export interface EmployeeNotification {
  id: number;
  kind: string;
  title: string;
  body: string | null;
  /** A web route to open on click, or null. */
  linkPath: string | null;
  refType: string | null;
  refId: number | null;
  /** `yyyy-MM-dd HH:mm:ss` */
  createdDate: string;
  read: boolean;
}

export interface NotificationInbox {
  unreadCount: number;
  items: EmployeeNotification[];
}

/** `common.dto.ApiResponse`: PascalCase, and `success` fills `Data1`. */
interface ApiEnvelope<T> {
  Data1?: T;
  Message?: string;
}

export const fetchMyNotifications = async (): Promise<NotificationInbox> => {
  const { data } = await api.get<ApiEnvelope<NotificationInbox>>(API_ENDPOINTS.EMPLOYEE_NOTIFICATIONS.MINE);
  return data?.Data1 ?? { unreadCount: 0, items: [] };
};

export const markNotificationRead = async (id: number): Promise<void> => {
  await api.put(API_ENDPOINTS.EMPLOYEE_NOTIFICATIONS.READ(id));
};

export const markAllNotificationsRead = async (): Promise<void> => {
  await api.put(API_ENDPOINTS.EMPLOYEE_NOTIFICATIONS.READ_ALL);
};
